import React from 'react'
import PropTypes from 'prop-types'

import ReactLoading from 'react-loading'

import styles from './styles.module.css'

const Button = ({
  width,
  height,
  style,
  className,
  type,
  children,
  disabled,
  ghost,
  loading,
  ...props
}) => {
  return (
    <a
      className={`${styles.shine_btn} ${type} ${disabled ? 'disabled' : ''} ${
        ghost ? 'ghost' : ''
      } ${className}`}
      style={{ width, height, ...style }}
      disabled={disabled}
      {...props}
      onClick={!loading && !disabled ? props.onClick : () => {}}
    >
      {children}
      {loading && (
        <div style={{ marginRight: 6 }}>
          <ReactLoading
            type={'spinningBubbles'}
            color={'#ffffff'}
            width={25}
            height={25}
          />
        </div>
      )}
    </a>
  )
}

Button.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'danger']),
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
}

Button.defaultProps = {
  width: '100%',
  height: '44px',
  style: {},
  className: '',
  type: 'primary',
}

export default Button
